import { render } from "./ModalEditarTipoAcomodacao.vue?vue&type=template&id=16eff311&scoped=true"
import script from "./ModalEditarTipoAcomodacao.vue?vue&type=script&lang=js"
export * from "./ModalEditarTipoAcomodacao.vue?vue&type=script&lang=js"

import "./ModalEditarTipoAcomodacao.vue?vue&type=style&index=0&id=16eff311&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16eff311"]])

export default __exports__